import {BaseFilter} from './base.filter';

export class ConfigurationFilter extends BaseFilter {
    locationId: string;
}
